import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { saveUser } from '../actions/account';

import HomeNav from '../components/HomeNav';
import Alert from 'react-s-alert';
import { useGetUsersQuery } from '../services/customers';
import { userPermissions } from './UserDashboard';

const UserList = () => {
    const location = useLocation();
    const params = useParams();
    const [lastEdited, setLastEdited] = React.useState(null);
    let filters = null;
    if (params.channel === 'admins') {
        filters = `?where={"permissions": {"$in": ["admin"]}}`;
    }
    if (params.channel === 'bop') {
        filters = `?where={"sites": {"$in": ["${params.channel}"]}}`;
    }
    const { data, isFetching, isError, refetch } = useGetUsersQuery(filters, {
        skip: !params.channel || !filters
    });

    const handleUndo = async () => {
        try {
            let userId = lastEdited._id;
            let newPermissions = [lastEdited.permissions, userPermissions.ADMIN];
            await saveUser(userId, { permissions: newPermissions });
            refetch();
        } catch (error) {
            console.error(error);
        }
    };

    const handleRemoveAdmin = async (userId) => {
        try {
            const user = data.find((user) => user._id === userId);
            const newPermissions = user.permissions.filter(
                (p) => p !== userPermissions.ADMIN && p !== userPermissions.READONLY
            );
            setLastEdited(user);
            await saveUser(userId, { permissions: newPermissions });
            refetch();
            Alert.success(
                <>
                    Admin access Removed for {user.email}.{' '}
                    <a href="#undo" onClick={handleUndo}>
                        Undo
                    </a>
                </>
            );
        } catch (error) {
            console.error(error);
        }
    };

    const header = (() => {
        switch (params.channel) {
            case 'admins':
                return 'Admins';
            case 'bop':
                return 'BOP Users';
            default:
                return 'Unknown';
        }
    })();

    return (
        <div>
            <HomeNav />
            <div className="container">
                <h1>{header}</h1>
                {isFetching && <div>loading...</div>}
                {!isFetching && !isError && (
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((user) => {
                                return (
                                    <tr key={user._id}>
                                        <td>
                                            <Link
                                                to={`/customer/${user._id}`}
                                                state={{
                                                    from: { pathname: location.pathname, title: header }
                                                }}
                                            >
                                                {user.name ? `${user.name.given} ${user.name.family}` : 'No Name'}
                                            </Link>
                                        </td>
                                        <td>{user.email}</td>
                                        <td>
                                            {params.channel === 'admins' && (
                                                <button
                                                    className="button button-small"
                                                    onClick={() => handleRemoveAdmin(user._id)}
                                                >
                                                    Remove Admin
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default UserList;
